import { render } from "./QuizStats.vue?vue&type=template&id=455996f4&scoped=true"
import script from "./QuizStats.vue?vue&type=script&lang=js"
export * from "./QuizStats.vue?vue&type=script&lang=js"

import "./QuizStats.vue?vue&type=style&index=0&id=455996f4&scoped=true&lang=css"

import exportComponent from "/home/runner/work/logexpo/logexpo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-455996f4"]])

export default __exports__
import QIcon from 'quasar/src/components/icon/QIcon.js';
import QBtn from 'quasar/src/components/btn/QBtn.js';
import QSpinner from 'quasar/src/components/spinner/QSpinner.js';import ClosePopup from 'quasar/src/directives/ClosePopup.js';
import qInstall from "../../node_modules/vue-cli-plugin-quasar/lib/runtime.auto-import.js";
qInstall(script, 'components', {QIcon,QBtn,QSpinner});qInstall(script, 'directives', {ClosePopup});
